import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c9767e5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2c9767e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9767e5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Verification: require('/var/jenkins_home/workspace/prod-web-xfans/components/verificationCode/verification.vue').default})
